import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import Suggestion from "../entities/pdv/suggestion.entity";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class SuggestionDB extends FirestorePipe {

  public static readonly colName = 'Suggestions'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${SuggestionDB.colName}`);
  }

  public create(data: Suggestion): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: Suggestion): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<Suggestion[]> {
    return this._getAll<Suggestion>(...params);
  }
  public get(id: string): Promise<Suggestion> {
    return this._get(id);
  }
  public on(listener: (data: Suggestion[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default SuggestionDB;